export const Footer = ({ email, logoW, logoS }) => {
  return (
    <>
      {/**Parte superior del foooter */}
      <div className='newsletter-area'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-5 col-md-5'>
              <div className='newsletter-content'> </div>
            </div>
            <div className='col-lg-7 col-md-7'>
              <div className='newsletter-form angle'>
                <div className='mailchimp-alerts text-centre fix pull-right'>
                  <div className='mailchimp-submitting'> </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/**Contenido del footer */}
      <div className='footer-widget-area'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-3 col-md-6'>
              <div className='single-footer-widget'>
                <div className='footer-logo'>
                  <a href='index.html'>
                    <img src={logoW} alt='' />
                  </a>
                </div>
              </div>
            </div>
            <div className='col-lg-1 col-md-6'></div>
            <div className='col-lg-5 col-md-6'>
              <div className='single-footer-widget'>
                <h3>CONTÁCTANOS</h3>
                <a href='tel:(662) 1080630'>
                  <i className='fa fa-phone'></i>(662) 1080630
                </a>
                <span>
                  <i className='fa fa-envelope'></i>
                  {email}
                </span>
                <a target='_blank' href='http://creson.edu.mx/'>
                  <i className='fa fa-globe'></i>http://creson.edu.mx/
                </a>
                <span>
                  <i className='fa fa-map-marker'></i>Carretera Federal 15,
                  kilómetro 10.5, Col. Café Combate, Hermosillo, Sonora, México.
                  C.P. 83165
                </span>
              </div>
            </div>
            <div className='col-lg-3 col-md-6'>
              <div className='single-footer-widget'>
                <div className='footer-logo'>
                  <a href='index.html'>
                    <img src={logoS} alt='' />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/** Barra inferior del footer (barra verde) */}
      <footer className='footer-area'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6 col-md-7 col-12'></div>
            <div className='col-lg-6 col-md-5 col-12'>
              <div className='column-right'></div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
